import { render } from "./BookRoom.vue?vue&type=template&id=1e19d51a&scoped=true"
import script from "./BookRoom.vue?vue&type=script&lang=js"
export * from "./BookRoom.vue?vue&type=script&lang=js"

import "./BookRoom.vue?vue&type=style&index=0&id=1e19d51a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e19d51a"]])

export default __exports__